<template>
  <div class="cashier-page">
    <div class="verify-box">
      <div class="scan-card">
        <h3>核销</h3>
        <p>输入或扫码核销码，复用现有订单核销接口。</p>
        <el-input v-model="hexiao.code" size="large" placeholder="请输入核销码" clearable @keyup.enter.native="searchCode(false)">
          <el-button slot="append" icon="el-icon-search" @click="searchCode(false)">查询</el-button>
        </el-input>
      </div>
      <div class="result-card" v-if="hexiaoInfo">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="订单号">{{ hexiaoInfo.order_sn }}</el-descriptions-item>
          <el-descriptions-item label="核销码">{{ hexiaoInfo.hexiao_code }}</el-descriptions-item>
          <el-descriptions-item label="自提点">{{ hexiaoInfo.store_name }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ hexiaoInfo.hexiao_status_str }}</el-descriptions-item>
          <el-descriptions-item label="会员">
            {{ hexiaoInfo.member ? hexiaoInfo.member.name : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="核销时间">{{ hexiaoInfo.hexiao_time || '-' }}</el-descriptions-item>
        </el-descriptions>
        <div class="verify-goods">
          <div class="verify-goods-item" v-for="item in hexiaoInfo.goods" :key="item.goods_name + item.specs_name">
            <img :src="item.goods_img" />
            <div>
              <strong>{{ item.goods_name }}</strong>
              <span>{{ item.specs_name || '默认' }} x{{ item.quantity }}</span>
            </div>
            <b>￥{{ money(item.pay_price || item.price) }}</b>
          </div>
        </div>
        <el-button type="primary" :disabled="!!hexiaoInfo.hexiao_time" @click="searchCode(true)">确认核销</el-button>
      </div>
    </div>
    <div class="log-card">
      <h3>核销记录</h3>
      <selffetch-log></selffetch-log>
    </div>
  </div>
</template>

<script>
import SelffetchLog from '@/components/Order/SelffetchLog'

export default {
  components: {
    SelffetchLog
  },
  data() {
    return {
      hexiao: {
        type: 1,
        code: ''
      },
      hexiaoInfo: false
    }
  },
  methods: {
    money(value) {
      return Number(value || 0).toFixed(2)
    },
    searchCode(status) {
      if (!this.hexiao.code) {
        this.fail('请输入核销码')
        return
      }
      const params = {
        type: 1,
        is_hexiao: status ? 1 : 0,
        code: this.hexiao.code
      }
      this.showLoading()
      this.$api.order.orderHexiao(params, res => {
        this.hideLoading()
        if (res.errcode === 0) {
          if (params.is_hexiao === 1) {
            this.success(res.errmsg)
            this.searchCode(false)
          } else {
            this.hexiaoInfo = res.data
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.cashier-page {
  display: grid;
  gap: 18px;
}
.verify-box {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 18px;
}
.scan-card,
.result-card,
.log-card {
  background: #fff;
  border-radius: 8px;
  padding: 18px;
}
.scan-card h3,
.log-card h3 {
  margin: 0 0 6px;
}
.scan-card p {
  margin: 0 0 18px;
  color: #8a96a8;
}
.verify-goods {
  margin: 14px 0;
}
.verify-goods-item {
  display: grid;
  grid-template-columns: 52px 1fr 100px;
  gap: 10px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #edf0f5;
}
.verify-goods-item img {
  width: 52px;
  height: 52px;
  border-radius: 6px;
  object-fit: cover;
}
.verify-goods-item div {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.verify-goods-item span {
  color: #8a96a8;
  font-size: 12px;
}
.verify-goods-item b {
  color: #f5222d;
}
</style>
